module.exports = __webpack_public_path__ + "img/activity.38de59ae.png";